<div class="motivationTicket-container" [ngClass]="{'is-mobile-view': isMobileView}" (click)="ticketClicked()" >
    <div class="motivationTicket-dataContainer">
        <div class="motivationTicket-firstPart">
            <div class="motivationTicket-dataStart" [ngStyle]="{'background-color':motivationColor}" [ngClass]="{'is-mobile-view': isMobileView}">
                <mat-icon class="motivationTicket-motivationIcon">{{icon}}</mat-icon>
                <span class="motivationTicket-motivationName" [ngClass]="{'is-mobile-view': isMobileView}">{{name}}</span>
            </div>
            <mat-icon *ngIf="presentRaiseDriver" class="motivationTicket-clickableIcon" (click)="raiseDriverClicked()" >add_circle</mat-icon>    
        </div>
        <app-trend-text *ngIf="isTrendValueExists && !hideTrendAndScore" [trendScore]="trend" [fontSize]="'12px'" [isUnknownTrendValue]="hideTrendAndScore"></app-trend-text>
    </div>
    @if(presentEnergyLevel){
        <div class="motivationTicket-progressBarContainer">
                <div [ngClass]="trendColor"><mat-progress-bar class="motivationTicket-progressBar" mode="determinate" value="{{score*20}}"></mat-progress-bar></div>
        </div>
    }
</div> 